import React from 'react';

// eslint-disable-next-line react-hooks/exhaustive-deps
const useMountEffect = (func: React.EffectCallback) => React.useEffect(func, []);

export default useMountEffect;
